const axios = require('axios').default

const setCookieEndPoint = `${process.env.API_SESSION_COOKIE_CREATION_ENDPOINT}`

export default {
  create() {
    const timestamp = new Date().valueOf()
    return axios.get(`${setCookieEndPoint}?t=${timestamp}`).catch(function (error) {
      console.log(JSON.stringify(error))
    })
  }
}
